<template>
  <div>
    <div style="padding-left: 30px" class="buttomsasd">
      <el-form :model="entity" label-position="right" label-width="130px" ref="form" :rules="validationRules">
        <el-form-item label="单位" prop="teamId">
<!--          <el-tree :data="teamTreeData" :props="teamTreeProps" style="width: 74%" @node-click="handleNodeClick"></el-tree>-->

          <treeselect v-model="this.entity.teamId" :options="teamTreeData"  :normalizer="normalizer" style="width: 400px;"/>

        </el-form-item>

        <el-form-item label="工号" prop="account">
          <el-input
            style="width: 74%"
            type="text"
            v-model.trim="entity.account"
            placeholder="请输入最少6位"
            maxlength="11"
            minlength="6"
            oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
            :disabled="false"
            v-if="!this.params.id || this.params.id === null"
          />
        </el-form-item>
        <el-form-item v-if="!params.id" label="密码" prop="password">
          <el-input type="text" v-model="entity.password" placeholder="请输入6~12位密码" show-password style="width: 74%" />
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input type="text" v-model="entity.name" style="width: 74%" />
        </el-form-item>
        <el-form-item label="电话" prop="phoneNum">
          <el-input style="width: 74%" type="text" v-model="entity.phoneNum" maxlength="11" onkeyup="value=value.replace(/[^\d\.]/g,'')" />
        </el-form-item>
        <el-form-item label="人员成本" prop="ext1">
          <el-input style="width: 74%" type="text" v-model="entity.ext1" />
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio v-model="entity.sex" :datas="parSex" label="男"></el-radio>
          <el-radio v-model="entity.sex" :datas="parSex" label="女"></el-radio>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button style="width: 150px" type="primary" @click="save()" size="small">提交</el-button>
        <el-button style="width: 150px; margin-left: 20px" type="danger" @click="close()" size="small">关闭</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default {
  components: {
    Treeselect
  },
  props: {
    params: Object
  },
  data() {
    return {
      teamTreeProps:{
        children: 'children',
        label: 'name'
      },
      teamTreeData:[],
      validationRules: {
        teamId: [{ required: true, message: '请选择单位', trigger: 'blur' }],
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { pattern: /\b\d{6,11}\b/, message: '账号长度 6 位至 11 位', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]+$/, message: '请输入数字或字母', trigger: 'blur' }
        ],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phoneNum: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          { pattern: /^1([35678]\d|5[0-9]|7[3678])\d{8}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        ext1: [{ required: true, message: '请输入薪资', trigger: 'blur' }]
      },
      treePicker: {
        url: `${$api_eap.team.tree}`,
        params: {},
        toLabel: 'name',
        expandAll: false
      },
    entity: {
        id: null,
        teamId: sessionStorage.getItem('userIdval') ? sessionStorage.getItem('userIdval') : '',
        account: null,
        password: null,
        sex: '男',
        birthday: null,
        phoneNum: null
      },
      account_ca: '',
      param: {
        keyName: 'id',
        parentName: 'pid',
        titleName: 'name',
        dataMode: 'tree',
        datas: ''
      },
      parSex: [
        { key: '男', title: '男' },
        { key: '女', title: '女' }
      ]
    };
  },
  mounted() {
    this.loadTeamTreeDataHttp();
    // this.account_ca = '';
    // if (this.params.teamId !== '') {
    //   this.$store.dispatch('changeNodeName', this.params.teamName);
    //   this.$store.dispatch('changeTreePick', this.params.teamId);
    // }
    // if (this.params.id != null) {
    //   this.leftForById();
    // }
  },
  methods: {
    loadTeamTreeDataHttp(){
      httpKit.post($api_eap.team.tree).then(res => {
        if (res.data.code === '200') {
          if (res.data.data.length > 0) {
            this.teamTreeData = res.data.data;
          }
        }
      });
    },
  normalizer(node) {
      return {
          id: node.id,
          label: node.name,
          children: node.children,
      }
  },
    handleNodeClick(node){

    },
    close() {
      this.$emit('close');
    },
    success() {
      this.$emit('success');
    },
    async save() {
      let res = await this.$refs.form.validate();
      console.log(res);
      if (!res) {
        return;
      }
      // 编辑
      let loading = this.$loading({ text: '保存中，请稍等' });
      if (this.params.id !== null) {
        httpKit.post($api_eap.user.save, this.entity).then(res => {
          loading.close();
          if (res.data.code === '200') {
            this.$message.success('保存成功');
            this.success();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        let loading = this.$loading({ text: '保存中，请稍等' });
        let par = {
          account: this.datas.account
        };
        httpKit.post($api_eap.user.account, par).then(res => {
          if (res.data.code === '200') {
            httpKit.post($api_eap.user.save, this.datas).then(res => {
              loading.close();
              if (res.data.code === '200') {
                this.$message.success('保存成功');
                this.success();
                // this.$emit('close');
              } else {
                this.$message.error(res.data.msg);
              }
            });
          } else {
            loading.close();
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    tree() {
      httpKit.post($api_eap.team.tree).then(res => {
        if (res.data.code === '200') {
          if (res.data.data.length > 0) {
            this.param.datas = res.data.data;
            treeFor(this.param.datas, 'name');
          }
        }
      });
    },
    leftForById() {
      httpKit.post($api_eap.user.info, { id: this.params.id }).then(res => {
        if (res.data.code === '200') {
          this.datas = res.data.data;
          this.$store.dispatch('changeNodeName', this.datas.teamName);
          this.$store.dispatch('changeTreePick', this.datas.teamId);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.buttomsasd /deep/.el-form-item {
  margin-bottom: 20px;
}
</style>
